import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';

//Admin
import * as Client from './Client';
import * as ClientUser from './ClientUser';
import * as ClientJobTemplate from './ClientJobTemplate';
import * as ClientJobTemplateContact from './ClientJobTemplateContact';
import * as ClientJobTemplateNccClass from './ClientJobTemplateNccClass';
import * as ClientJobTemplateChecklist from './ClientJobTemplateChecklist';
import * as Report from './Report';

//Business
import * as Job from './Job';
import * as Property from './Property';
import * as JobContact from './JobContact';
import * as Owner from './Owner';
import * as JobNote from './JobNote';
import * as Document from './Document';
import * as ReceivedDocument from './ReceivedDocument';
import * as SubJob from './SubJob';
import * as JobChecklist from './JobChecklist';
import * as Invoice from './Invoice';
import * as JobNccClass from './JobNccClass';
import * as JobRequiredCertificate from './JobRequiredCertificate';
import * as JobAspectCertificate from './JobAspectCertificate';
import * as CouncilApplication from './CouncilApplication';


import * as PublicLodge from './PublicLodge';


//其他Section级js都引用进来
const sections = {
  //Admin
  'Client': Client,
  'ClientUser': ClientUser,
  'ClientJobTemplate': ClientJobTemplate,
  'ClientJobTemplateContact': ClientJobTemplateContact,
  'ClientJobTemplateNccClass': ClientJobTemplateNccClass,
  'ClientJobTemplateChecklist': ClientJobTemplateChecklist,
  'Report': Report,

  //Business
  'Job': Job,
  'Property': Property,
  'JobContact': JobContact,
  'Owner': Owner,
  'JobNote': JobNote,
  'Document': Document,
  'ReceivedDocument': ReceivedDocument,
  'SubJob': SubJob,
  'JobChecklist': JobChecklist,
  'Invoice': Invoice,
  'JobNccClass': JobNccClass,
  'JobRequiredCertificate': JobRequiredCertificate,
  'JobAspectCertificate': JobAspectCertificate,
  'CouncilApplication': CouncilApplication,

  'PublicLodge': PublicLodge,
};

//调用函数的主入口, e是触发事件
export function operationalFunction({ e, functionName, sectionName, parameter, data, formComponent, sectionComponent, pageComponent, uie, callback, showError = true } = {}) {
  // console.log(functionName, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie, callback);
  sectionName = sectionName || null;
  try {
    if (functionName != null && sectionName != null && typeof sections[sectionName][functionName] === 'function') {
      sections[sectionName][functionName]({ e: e, parameter: parameter, data: data, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
    } else if (functionName != null && typeof eval(functionName) === 'function') {
      eval(functionName)({ e: e, parameter: parameter, data: data, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie })
    }
    if (typeof callback === 'function') {
      callback.call(parameter, formComponent, sectionComponent, pageComponent, sectionName, uie);
    }
  } catch (error) {
    if (showError) {
      console.log('Not find function "' + functionName + '" in Common and ' + sectionName + ' section, or have Exception');
    }
    // globalFunction.handleError(error, pageComponent);
  }
}

//通用的点击添加按钮逻辑, 打开渲染表单Modal并设置为Create
function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的点击添加按钮逻辑');
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  pageComponent.setState({ selectedDocumentList: [] });

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    sectionComponent.customForm.current?.formRef.current?.resetFields();
    setTimeout(() => {
      let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
      sectionComponent.props.section.componentList.filter(c => c.type === 'Create')[0].groupList.forEach(group => {
        group.uieList.forEach(uie => {
          switch (uie.component) {
            case 'Select':
              let selectValue = null;
              if (componentDataSource[uie.source] !== undefined) {
                if (uie.type === 'group') {
                  componentDataSource[uie.source].some(group => {
                    if (group.SelectOptionList === null) {
                      selectValue = group.Value;
                      return true;
                    }
                    return group.SelectOptionList.some(selectOption => {
                      selectValue = selectOption.Value;
                      return true;
                    });
                  });
                } else {
                  if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                    selectValue = componentDataSource[uie.source][0]?.Value;
                  }
                  if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                    selectValue = [];
                  }
                }
              }
              if (uie.autoSelect) {
                //如果是自定义AutoSelect的类型, 触发其onChange事件
                if (componentDataSource[uie.source] !== undefined) {
                  operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: selectValue, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                }
              } else {
                //处理Select默认选项, 如果字段的备选项列表已加载, 则自动选择备选项里第一个
                if (componentDataSource[uie.source] !== undefined) {
                  sectionComponent.customForm.current?.formRef.current?.setFieldValue(uie.source, selectValue);
                }
              }
              break;

            case 'ColorPicker':
              sectionComponent.customForm.current?.formRef.current?.setFieldValue(uie.source, config.component.ColorPicker.defaultColor);
              break;
          }
        });
      });

      let functionName = 'add' + sectionName + 'PopUpRun';
      try {
        if (typeof sections[sectionName][functionName] === 'function') {
          sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
        }
      } catch (error) { }
      sectionComponent.setState({ isFormModified: false });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//通用的点击编辑按钮逻辑, 打开渲染表单Modal并设置为Edit
function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的点击编辑按钮逻辑');
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  pageComponent.setState({ selectedDocumentList: [] });

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
          //处理不适合antd组件的数据
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
            group.uieList.forEach(uie => {
              switch (uie.component) {
                case 'DatePicker':
                  //处理日期, 把字符串转成moment
                  if (data.data[uie.source] !== null && data.data[uie.source] !== undefined) {
                    data.data[uie.source] = moment(data.data[uie.source], config.format.date);
                  } else {
                    data.data[uie.source] = undefined;
                  }
                  break;
                case 'Select':
                  //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                  if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                    if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                      data.data[uie.source] = componentDataSource[uie.source][0]?.Value;
                    }
                    if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                      data.data[uie.source] = [];
                    }
                  }
                  if (uie.autoSelect) {
                    //如果是自定义AutoSelect的类型, 触发其onChange事件
                    operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: data.data[uie.source], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                  }
                  break;
                case 'RichTextEditor':
                  //处理RichTextEditor, 如果是null或者undefined，改为空字符串，否则会崩溃
                  if (data.data[uie.source] === null) {
                    data.data[uie.source] = '';
                  }
                  break;
                case 'Input':
                  //处理Input, 如果type是fileName, 处理成改文件名的状态
                  if (uie.type === 'fileName') {
                    uie.addonAfter = globalFunction.getExtension(data.data[uie.source]);
                    data.data[uie.source] = globalFunction.getFileNameWithoutExtension(data.data[uie.source]);
                  }
                  break;
              }
            });
          });
          //把处理后的数据赋值给表单
          console.log(data.data);
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });
          sectionComponent.setState({ dataLoading: false });
          let functionName = 'edit' + sectionName + 'PopUpRun';
          try {
            if (typeof sections[sectionName][functionName] === 'function') {
              sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie, data: data.data });
            }
          } catch (error) { }
          sectionComponent.setState({ isFormModified: false });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

//通用的点击删除按钮逻辑, 弹出提示, 确认后删除并刷新Section
function deleteBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的点击删除按钮逻辑');
  httpClient
    .delete(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        if (data.code === 2) {
          message.error(data.message);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//通用的排序, 后台返回成功信息后刷新Section
function sortBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的排序逻辑');
  httpClient
    .post(pageComponent.props.areaName + '/' + sectionName + '/Sort', parameter)
    .then(({ data }) => {
      if (data.result) {
        // 无需刷新, 直接用内存里的变量
        // sectionComponent.getSectionDataByDefault();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//通用的点击提交自定义表单按钮逻辑, 提交绑定的form
function submitCustomForm({ parameter, sectionComponent, pageComponent, sectionName } = {}) {
  let canSubmit = true;
  let errorInfo = '';
  //处理RichTextEditor必填却没填的情况
  sectionComponent.props.section.componentList.filter(c => c.type === sectionComponent.state.componentType)[0].groupList.forEach(group => {
    group.uieList.forEach(uie => {
      switch (uie.component) {
        case 'RichTextEditor':
          if (uie.required && globalFunction.isNullOrEmpty(sectionComponent.customForm.current?.formRef.current?.getFieldValue(uie.source))) {
            errorInfo += uie.source + ' can not be empty.\r\n';
            canSubmit = false;
          }
          break;
      }
    });
  });
  if (canSubmit) {
    sectionComponent.customForm.current?.submitForm();
  } else {
    message.error(errorInfo);
  }
}

//通用的提交自定义表单, 表单验证通过后在这里执行提交, 后台返回结果后刷新Section
function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ customFormSubmitting: true });
  let areaName = sectionComponent.props.areaName;
  let pageName = sectionComponent.props.pageName;
  let form = formComponent.formRef.current?.getFieldsValue();

  formComponent.props.component.groupList.filter(c => c.show).forEach(group => {
    group.uieList.forEach(uie => {
      if (uie.component === 'DatePicker') {
        if (form[uie.source] !== undefined && form[uie.source] !== null) {
          form[uie.source] = moment(form[uie.source]).format(config.format.sqlDate);
        } else {
          form[uie.source] = null;
        }
      }
      if (uie.component === 'ColorPicker') {
        if (form[uie.source] !== undefined) {
          form[uie.source] = form[uie.source].hex
        } else {
          form[uie.source] = null;
        }
      }
    });
  });

  if (parameter !== undefined) {
    for (let key in parameter) {
      form[key] = parameter[key];
    }
  }

  //处理一些特殊的自定义字段
  form.key = formComponent.state.currentDataKey;
  console.log(sectionComponent.state.componentType + ' 提交的表单', form);

  switch (sectionComponent.state.componentType) {
    case 'Create':
      httpClient
        .post(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            customFormFinish({ data: data.data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
    case 'Edit':
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            customFormFinish({ data: data.data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
          } else {
            globalFunction.handleResultError(data);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
  }
}

//添加或修改完成，处理后续重置按钮或刷新Section等事宜
function customFormFinish({ data, parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (formComponent.props.component.onSubmitFinish !== null) {
    if (typeof sections[sectionName][formComponent.props.component.onSubmitFinish] === 'function') {
      sections[sectionName][formComponent.props.component.onSubmitFinish]({ parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
    }
  }
  sectionComponent.setState({ customFormSubmitting: false });
  setTimeout(() => {
    formComponent.resetFields();
    sectionComponent.setState({ showModal: false });
    setTimeout(() => {
      if (formComponent.props.component.refreshDataFunction !== null && typeof sections[sectionName][formComponent.props.component.refreshDataFunction] === 'function') {
        sections[sectionName][formComponent.props.component.refreshDataFunction]({ data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
      } else {
        sectionComponent.getSectionDataByDefault();
      }
      sectionComponent.setState({ componentType: null });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//通用的取消自定义表单
function cancelCustomForm({ parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.customForm.current?.resetFields();
  sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false });
  setTimeout(() => {
    sectionComponent.setState({ componentType: null });
  }, config.setTimeoutMilliSecond);
}

//通用的获取AutoComplete数据, 通过配置指定触发查询的最小字符数
export function getAutoCompleteData({ parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?key=' + parameter)
      .then(({ data }) => {
        if (data.result) {
          let componentDataSource = { ...sectionComponent.state.componentDataSource };
          componentDataSource[uie.source] = data.data;
          sectionComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//通用的获取uie数据源数据
export function getUieDataSource({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (uie.autoDataSource && uie.datasourceUrl !== null) {
    let parameterStr = '';
    parameter.forEach(item => {
      parameterStr += item.key + '=' + item.value + '&';
    })
    httpClient
      .get(uie.datasourceUrl + '?' + parameterStr)
      .then(({ data }) => {
        if (data.result) {
          if (data.data.length > 0) {
            let dataSource = data.data;
            let componentDataSource = { ...component.state.componentDataSource };
            if (uie.required) {
              dataSource = dataSource.filter(item => item.Value !== 0);
            }
            componentDataSource[uie.source] = dataSource;
            component.setState({ componentDataSource });
            setTimeout(() => {
              let formData = { ...component.state.formData };
              if (uie.autoSelect) {
                //如果是自定义AutoSelect的类型, 触发其onChange事件
                if (formData[uie.source] === null || formData[uie.source] === undefined) {
                  operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: dataSource[0]?.Value, data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                }
              } else {
                //否则给普通的Select设置默认值, 为第一个选项
                if (uie.component === 'Select' && uie.type !== 'multiple') {
                  if (formData[uie.source] === null || formData[uie.source] === undefined) {
                    if (uie.type === 'group') {
                      let dataSourceFilter = dataSource.filter(group => {
                        return group.SelectOptionList !== null && group.SelectOptionList.length > 0;
                      });
                      if (dataSourceFilter.length > 0) {
                        component.formRef.current?.setFieldValue(uie.source, dataSourceFilter[0].SelectOptionList[0]?.Value);
                      } else {
                        component.formRef.current?.setFieldValue(uie.source, dataSource[0]?.Value);
                      }
                    } else {
                      component.formRef.current?.setFieldValue(uie.source, dataSource[0]?.Value);
                    }
                  }
                  setTimeout(() => {
                    if (uie.onChange !== null && uie.autoChange) {
                      operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: component.formRef.current?.getFieldValue(uie.source), data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                    }
                  }, config.setTimeoutMilliSecond);
                }
              }
            }, config.setTimeoutMilliSecond);
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//通用的获取component数据源组
export function getComponentDataSourceGroup({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent } = {}) {
  let parameterStr = '';
  parameter.forEach(item => {
    parameterStr += item.key + '=' + item.value + '&';
  })

  httpClient
    .get(component.props.component.datasourceUrl + '?' + parameterStr)
    .then(({ data }) => {
      sectionComponent.setState({ renderForm: true });
      let componentDataSource = component.state.componentDataSource;
      if (data.result) {
        if (data.data.length > 0) {
          data.data.map((hash, i) => {
            let dataSource = hash.Value;
            let uie = null;
            component.props.component.groupList.filter(c => c.show).map((group, j) => {
              group.uieList.map((u, k) => {
                if (u.source == hash.Key) {
                  uie = u;
                }
              })
            })
            if (uie !== null) {
              if (uie.required) {
                dataSource = dataSource.filter(item => item.Value !== 0);
              }
              componentDataSource[hash.Key] = dataSource;
              setTimeout(() => {
                if (uie.autoSelect) {
                  //如果是自定义AutoSelect的类型, 触发其onChange事件
                  operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: dataSource[0]?.Value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                } else {
                  //否则给普通的Select设置默认值, 为第一个选项
                  if (uie.component === 'Select' && (uie.type === null || uie.type.indexOf('multiple') < 0)) {
                    let formData = { ...component.state.formData };
                    if (formData[uie.source] === null || formData[uie.source] === undefined) {
                      component.formRef.current?.setFieldValue(uie.source, dataSource[0]?.Value);
                    }
                    setTimeout(() => {
                      if (uie.onChange !== null) {
                        operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: component.formRef.current?.getFieldValue(uie.source), data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                      }
                    }, config.setTimeoutMilliSecond);
                  }
                }
              }, config.setTimeoutMilliSecond)
            }
          });
          component.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//打开发邮件界面
export function sendEmail({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent } = {}) {
  pageComponent.setState({ sendEmailShow: true, selectedDocumentList: [], selectedDocumentTotalSize: 0 });

  if (pageComponent.props.authUser.EmailSignature !== null) {
    setTimeout(() => {
      setEmailDefaultInfo(parameter, pageComponent)
    }, config.setTimeoutMilliSecond);
  } else {
    httpClient
      .get('Admin/CompanyUser/' + pageComponent.props.authUser.CompanyUserId)
      .then(({ data }) => {
        if (data.result) {
          pageComponent.props.authUser.EmailSignature = data.data.EmailSignature;
          pageComponent.props.setAuthUser(pageComponent.props.authUser);
          setTimeout(() => {
            setEmailDefaultInfo(parameter, pageComponent);
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function setEmailDefaultInfo(parameter, pageComponent) {
  pageComponent.sendEmail.current?.getSubject();
  pageComponent.sendEmail.current?.getCompanyEmailTemplate();
  pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldsValue({ To: [], CC: [], BCC: [], Subject: '', Body: pageComponent.props.authUser.EmailSignature !== null ? pageComponent.props.authUser.EmailSignature : '' });
  if (!globalFunction.isNullOrEmpty(parameter.Email)) {
    pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldValue('To', parameter.Email.split(',').map(item => item.trim()));
  }
}

//打开发短信界面
export function sendSMS({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent } = {}) {
  pageComponent.setState({ sendSMSShow: true });
  setTimeout(() => {
    pageComponent.sendSMS.current?.setState({ parameter: parameter });
  }, config.setTimeoutMilliSecond);
}

//Suburb控件 找自动Suburb和Postcode
export function searchSuburbChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&state=' + pageComponent.state.state)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((suburb, j) => {
            options.push({ label: suburb.Name + ' (' + suburb.Postcode + ')', value: suburb.Name + ' (' + suburb.Postcode + ')', data: suburb });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//Suburb 选择后快速填写数据
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('Suburb', data.data.Name);
  formComponent.formRef.current?.setFieldValue('Postcode', data.data.Postcode);
}

//PostalSuburb 选择后快速填写数据
export function searchPostalSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('PostalSuburb', data.data.Name);
  formComponent.formRef.current?.setFieldValue('PostalPostcode', data.data.Postcode);
}

export function getStatsDataByDefault({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  sectionComponent.getStatsDataByDefault();
}
